import { portalApi } from '../../../store/generated/portal/assessments/plans-organization';

export enum ActionPlanApiTags {
  ActionPlan = 'ActionPlan',
}

const actionPlanApi = portalApi.enhanceEndpoints({
  addTagTypes: [ActionPlanApiTags.ActionPlan],
  endpoints: {
    apiPortalV1AssessmentsPlansOrganizationList: {
      providesTags: [ActionPlanApiTags.ActionPlan],
    },
    apiPortalV1AssessmentsPlansOrganizationRetrieve: {
      providesTags: [ActionPlanApiTags.ActionPlan],
    },
    apiPortalV1AssessmentsPlansOrganizationUpdate: {
      invalidatesTags: [ActionPlanApiTags.ActionPlan],
    },
    apiPortalV1AssessmentsPlansOrganizationPartialUpdate: {
      invalidatesTags: [ActionPlanApiTags.ActionPlan],
    },
    apiPortalV1AssessmentsPlansOrganizationCreate: {
      invalidatesTags: [ActionPlanApiTags.ActionPlan],
    },
    apiPortalV1AssessmentsPlansOrganizationDestroy: {
      invalidatesTags: [ActionPlanApiTags.ActionPlan],
    },
  },
});

export { actionPlanApi };
